// src/features/editor/components/blocks/previews/DisabledBlockPreview.tsx
import { Lock } from 'lucide-react'
import { LessonCtaButton } from '@teach/ui'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface Props {
  /** Прохождение: выход с экрана неизвестного типа. По типам блок недостижим,
   *  но данные приезжают с бэка — тупика в прохождении быть не должно. */
  onNext?: () => void
}

export const DisabledBlockPreview = ({ onNext }: Props) => {
  const m = useMessages(messages)
  return (
    <div className="flex h-full w-full flex-col items-center justify-center gap-3 bg-muted text-muted-foreground">
      <Lock className="h-8 w-8" />
      <span className="text-sm">{m.unavailable}</span>
      {onNext ? <LessonCtaButton label={m.next} onClick={onNext} /> : null}
    </div>
  )
}
